<template>
  <div class="exam-page">
    <div class="exam-container">
      <div>
        <img width="65" src="/img/icons/click_on_left.svg">
        <br>
        <h2 class="color-white">Click on a left menu item to get started</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {
      collapsed: false
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN
    })
  },
  mounted() {
  	if (this.isLoggedIn) {
      this.contentList();
    } else {
      var link = "/login"
      if(this.$route.params.section) {
        link += "?section=" + this.$route.params.section
      }
      this.$router.push(link);
    }
  },
  watch: {
  	isLoggedIn: function(newVal) {
  		if(newVal) {
  			this.contentList();
  		} else {
        var link = "/login"
        if(this.$route.params.section) {
          link += "?section=" + this.$route.params.section
        }
        this.$router.push(link);
  		}
  	}
  },
  methods: {
    ...mapActions({
      getSectionDetail: types.GET_SECTION_DETAIL,
    	getContentList: types.GET_CONTENT_LIST,
      getQuizList: types.GET_QUIZ_LIST
    }),
    contentList() {
      if(this.$route.params.section) {
        this.getSectionDetail({id: this.$route.params.section})
        .then(response => {
          
        }).catch(error => {
          this.showMessageBox(error, "Failed to get contents", "danger");
        })

        this.getContentList({params: {section: this.$route.params.section}})
        .then(response => {
          
        }).catch(error => {
          this.showMessageBox(error, "Failed to get contents", "danger");
        })

        this.getQuizList({params: {section: this.$route.params.section}})
        .then(response => {

        }).catch(error => {
          this.showMessageBox(error, "Failed to get quiz", "danger");
        })
      } else {
        this.$router.push("/no-subject");
      }
    },
    showMessageBox(message, title, variant) {
      this.$bvModal.msgBoxOk(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
      .then(value => {
        this.temp = value
      })
      .catch(err => {
        this.temp = err;
      });
    }
  }
};
</script>

<style>
.dashboard-page {
  padding: 33px;
}

.exam-container {
  height: calc(100vh - 140px);
  background-image: linear-gradient(
    59deg,
    #56c8ff 1%,
    #2190e9 53%,
    #00cbae 114%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
}
</style>
